export default "__VITE_ASSET__DPqS2k7k__"